import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { ConfigService } from '../_services/config.service';
import { CompaniesService } from '../companies/services/companies.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(private configService: ConfigService, private router: Router, private companiesService: CompaniesService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		// Check if user is authenticated
		if (!this.configService.isAuthenticated()) {
			// Preserve guid and type if they exist (for password reset/registration flows)
			const guid = localStorage.getItem('guid');
			const type = localStorage.getItem('type');

			localStorage.clear();
			console.log('!this.configService.isAuthenticated()', 'login_due_fattori', 'route', route);

			// Restore guid and type after clearing
			if (guid) localStorage.setItem('guid', guid);
			if (type) localStorage.setItem('type', type);

			// Preserve query parameters when redirecting to login
			const queryParams = route.queryParams && Object.keys(route.queryParams).length > 0 ? route.queryParams : {};
			this.router.navigate(['/login_due_fattori'], { queryParams });
			return false;
		}

		return this.setupCompanies();
	}

	private setupCompanies(): Observable<boolean> {
		let cerca = '';
		let order = '';
		let limitda = 1;
		let pageelement = 1;

		let cmp_id = this.configService.getCompany_id();

		return this.companiesService.GetListCompanies(cmp_id, cerca, order, pageelement, limitda).pipe(
			map((data: any) => {
				const aziende = data;

				if (aziende.length == 1) {
					//Set cpompany Name
					localStorage.setItem('def_company_name', aziende[0].name);
					// Set company ID
					this.configService.setCompany_id(aziende[0].id);

					// Set logo
					const logo = aziende[0].cmp_logo_b64 ? 'data:image/png;base64,' + aziende[0].cmp_logo_b64 : '';
					this.configService.setCompanyLogo(logo);
					// Set theme
					let tema = aziende[0].cmp_tema;
					if (tema) {
						document.documentElement.setAttribute('kcs-theme', tema);
						localStorage.setItem('theme', tema);
					} else {
						document.documentElement.setAttribute('kcs-theme', 'default');
						localStorage.setItem('theme', 'default');
					}
				} else {
					// Multiple companies or no companies - set default theme
					document.documentElement.setAttribute('kcs-theme', 'default');
					localStorage.setItem('theme', 'default');
				}
				return true; // Allow navigation to proceed
			}),
			catchError((error) => {
				console.error('Error loading companies:', error);
				// On error, still allow navigation but with default settings
				document.documentElement.setAttribute('kcs-theme', 'default');
				localStorage.setItem('theme', 'default');
				return of(true);
			}),
		);
	}
}
